import { sum } from "lodash";
import moment from "moment";
import removeCommas from "../common/removeCommas";
import { BiCheckCircle } from "react-icons/bi";
import { useQuery } from "@tanstack/react-query";
import { getPosGroupedByJob } from "../stores/PoStore";
import { useEffect } from "react";
function useJob() {
  const { data: posGroupedByJob } = useQuery({
    queryFn: getPosGroupedByJob,
    queryKey: ["pos", "groupByJob"],
  });

  const start = ({ job }) => moment(job.jobStartDate).valueOf();
  const end = ({ job }) => moment(job.jobEndDate).valueOf();
  const today = () => moment(new Date().toDateString()).valueOf();

  const invoiceTotal = ({ job }) => Number(removeCommas(job.total));
  const invoiceBalance = ({ job }) => {
    return (
      invoiceTotal({ job }) -
      sum(job.payments?.map((i) => Number(removeCommas(i.amount))))
    );
  };

  const paymentStatus = ({ job }) => {
    return invoiceBalance({ job }) === invoiceTotal({ job })
      ? "Not Paid"
      : invoiceBalance({ job }) > 0
      ? "Partial"
      : "Completed";
  };

  const processStatus = ({ job }) => {
    const pos = posGroupedByJob?.[job._id];
    const po = pos ? pos[pos.length - 1] : undefined;

    return !job.noPo && !po
      ? "Waiting PO"
      : job.invoiceCreated
      ? invoiceBalance({ job }) <= 0
        ? "Completed"
        : "Payment"
      : "Waiting Invoice";
  };

  const jobStatus = ({ job }) => {
    const pos = posGroupedByJob?.[job._id];
    const po = pos ? pos[pos.length - 1] : undefined;

    return !job.noPo && !po ? (
      "Waiting PO"
    ) : today() > end({ job }) ? (
      <span className="d-flex" style={{ alignItems: "center", gap: 5 }}>
        <BiCheckCircle size={20} color={"green"} />
        Done
      </span>
    ) : today() > start({ job }) ? (
      "On Going"
    ) : (
      "Waiting to start"
    );
  };
  const tasks = ({ job }) => job.tasks;
  const findPath = ({ job }) => {
    const organization = job.organization;
    return `/organizations/view/${organization._id || organization}/jobs/${
      job._id
    }`;
  };

  const isJobDone = ({ job }) => {
    const pos = posGroupedByJob?.[job._id];
    const po = pos ? pos[pos.length - 1] : undefined;

    return !job.noPo && !po
      ? "Waiting PO"
      : today() > end({ job })
      ? true
      : today() > start({ job })
      ? "On Going"
      : "Waiting to start";
  };

  return {
    tasks,
    start,
    end,
    today,
    invoiceBalance,
    invoiceTotal,
    paymentStatus,
    processStatus,
    jobStatus,
    findPath,
    isJobDone,
  };
}

export default useJob;
